import React from 'react';

import {
  Dialog,
  DialogContent,
} from '@mui/material';
import { styles } from './styles';
import Loading from '../mui-components/Loading';


const LoadingDialog = (props) => {
  const { open } = props;
  return (
    <Dialog
      open={open}
      maxWidth="lg"
    >
      <DialogContent sx={styles.loadingBox}>
        <Loading />
      </DialogContent>
    </Dialog>
  )

}

export default LoadingDialog;